import { getProviderFromIntegrationClientKind } from '@/modules/assetProviderIntegrations/assetProviderIntegrations.utils';
import { getIntegrationProviderDisplayName } from '@/modules/assetProviderIntegrations/shared/constants';
import { IntegrationClientKind } from '@/types/schema';

export function getIntegrationProviderName(
  householdIntegrationLink: IntegrationClientKind | null
): string {
  if (!householdIntegrationLink) return 'Integration';
  const provider = getProviderFromIntegrationClientKind(
    householdIntegrationLink
  );
  return getIntegrationProviderDisplayName(provider) || 'Integration';
}
